import * as permissionUtils from 'common/wolt-permissions/permissionUtils';
import { OfferingMenuPermissions } from 'modules/shared-menu/types';

import { SHARED_MENU_DEFAULT_PERMISSIONS } from './constants';

export const buildMerchantBrandListingManagerPermissions = (permissions: string[]): OfferingMenuPermissions => {
  return {
    ...SHARED_MENU_DEFAULT_PERMISSIONS,
    woltSpecials: permissionUtils.hasWoltSpecialsViewPermission(permissions),
  };
};
